import type { TrainingDetail } from '@/entities/Training';

/**
 * SGQ Homologação trainings are created automatically by the document approval flow and have no
 * title of their own worth showing — the breadcrumb and page title show the linked document
 * instead, as `[prefixo] - [título]` (or just the prefix/título alone when the document is
 * missing the other one).
 */
export function resolveViewTrainingPageTitle(training: TrainingDetail): string {
  if (training.type !== 'SGQ_DOCUMENT_HOMOLOGATION') return training.title;

  const document = training.documents[0];
  if (!document) return training.title;

  if (!document.prefix) return document.title ?? training.title;

  return document.title ? `${document.prefix} - ${document.title}` : document.prefix;
}
